import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';
import { Params, SearchClient, SearchError, SearchResponse } from '@empathybroker/tsclient-search';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, ContextState, Dictionary, Filter, Pagination, SearchState } from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

import { SearchAction } from './search.action';

export class BrowseAction implements ActionClass {

  public static execute({ rootGetters }: ActionContext<SearchState, any>, payload: {
    filters: Dictionary<Filter>,
    pagination: Pagination,
    idParam: { [idKey: string]: string; },
    params?: Params
  }): Promise<SearchResponse | SearchError> {
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const instanceConfig: Instance = rootGetters[`${ CONFIG_CONSTS.moduleName }/${ CONFIG_CONSTS.getters.currentInstance }`];
    const searchClient: SearchClient = CONTAINER.get<(context: ContextState, instanceConfig: Instance) => SearchClient>(
      TYPES.SearchClient)(context, instanceConfig);
    const params = Object.assign(SearchAction.getSearchFilters(payload.filters), payload.params);
    const page = SearchAction.getSearchPage(payload.pagination);
    return searchClient.browse(payload.idParam, params, page);
  }

}
